var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from './icon';
import Button from './button';
import { fetchVehicleFluids, } from '../../http/vehicle-fluids';
export default (props) => {
    const [data, setData] = React.useState(undefined);
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
        if (!props.vin) {
            setData(undefined);
            return;
        }
        let cancelled = false;
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            setData(null);
            setError(false);
            try {
                const result = yield fetchVehicleFluids(props.merchantId, props.vin);
                if (!cancelled)
                    setData(result);
            }
            catch (_a) {
                if (!cancelled) {
                    setData({ applications: [] });
                    setError(true);
                }
            }
        });
        load();
        return () => { cancelled = true; };
    }, [props.merchantId, props.vin]);
    if (!props.vin || data === undefined)
        return null;
    const formatSpec = (item) => { var _a; return [item.viscosity, (_a = item.grade) === null || _a === void 0 ? void 0 : _a.description, item.specStandard].filter(Boolean).join(' / ') || 'N/A'; };
    const formatValueWithUnit = (value, unit) => value != null ? `${value} ${unit}` : '\u2014';
    const formatCapacityRange = (item) => {
        if (item.value != null)
            return formatValueWithUnit(item.value, item.unitOfMeasure);
        if (item.minValue != null && item.maxValue != null)
            return `${item.minValue}-${item.maxValue} ${item.unitOfMeasure}`;
        if (item.minValue != null)
            return `${item.minValue}+ ${item.unitOfMeasure}`;
        if (item.maxValue != null)
            return `Up to ${item.maxValue} ${item.unitOfMeasure}`;
        return '\u2014';
    };
    const flattenCapacities = (app) => app.capacities.flatMap((capacity) => capacity.items.map((item) => ({
        'name': capacity.name,
        'summary': formatCapacityRange(item),
        'notes': item.notes,
    })));
    const printSummary = () => {
        if (!data || data.applications.length === 0)
            return;
        const win = window.open('', '_blank');
        if (!win)
            return;
        const sections = data.applications.map((app) => {
            const fluidRows = app.items.map((item) => `
        <tr>
          <td style="padding:6px 8px;border-bottom:1px solid #ddd">
            ${formatSpec(item)}
            ${item.tradeName ? `<span style="color:#666"> (${item.tradeName})</span>` : ''}
            ${item.tempRange ? `<span style="color:#666"> [${item.tempRange}]</span>` : ''}
          </td>
        </tr>
      `).join('');
            const capacityLines = flattenCapacities(app).map((cap) => `
        <div style="font-size:12px;color:#666">
          <strong>${cap.name}:</strong> ${cap.summary}${cap.notes.length > 0 ? ` \u2014 ${cap.notes.join(', ')}` : ''}
        </div>
      `).join('');
            return `
        <div style="margin-bottom:18px">
          <div style="font-weight:600;font-size:14px">${app.name}</div>
          ${app.description ? `<div style="font-size:12px;color:#666;margin-bottom:4px">${app.description}</div>` : ''}
          ${fluidRows ? `<table style="width:100%;border-collapse:collapse;font-size:13px;margin:4px 0">
            <thead><tr><th style="text-align:left;padding:6px 8px;background:#f0f0f0;border-bottom:2px solid #ccc">Recommended Fluid</th></tr></thead>
            <tbody>${fluidRows}</tbody>
          </table>` : ''}
          ${capacityLines}
        </div>
      `;
        }).join('');
        win.document.write(`<!DOCTYPE html>
<html><head><title>Recommended Fluids - ${props.vin}</title>
<style>
  body { font-family: Arial, sans-serif; margin: 20px 30px; color: #333; }
  h1 { font-size: 18px; margin-bottom: 4px; }
  .meta { font-size: 13px; color: #666; margin-bottom: 16px; }
  @media print { body { margin: 10mm; } }
</style>
</head><body>
  <h1>Recommended Fluids</h1>
  <div class="meta"><strong>VIN:</strong> ${props.vin}</div>
  ${sections}
  <div style="margin-top:20px;font-size:11px;color:#999">Printed ${new Date().toLocaleDateString()}</div>
<script>window.print()</script>
</body></html>`);
        win.document.close();
    };
    return _jsxs("div", { className: "mt-3", children: [_jsxs("div", { className: "d-flex align-items-center justify-content-between mb-2", children: [_jsxs("div", { className: "d-flex align-items-center", children: [_jsx(Icon, { size: "inherit", children: "water_drop" }), _jsx("strong", { className: "ms-1", children: "Recommended Fluids" })] }), !!data && !error && data.applications.length > 0 && _jsx(Button, { color: "secondary", onClick: printSummary, title: "Print Fluids", children: _jsx(Icon, { size: "inherit", children: "print" }) })] }), data === null && _jsx("div", { className: "text-center py-2", children: _jsx("div", { className: "spinner-border spinner-border-sm text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) }), error && _jsx("div", { className: "text-muted small", children: "Unable to load fluid recommendations for this VIN." }), data && !error && data.applications.length === 0 && _jsx("div", { className: "text-muted small", children: "No fluid data available for this vehicle." }), data && !error && data.applications.length > 0 && _jsx("div", { children: data.applications.map((app) => _jsxs("div", { className: "mb-3", children: [_jsx("div", { className: "fw-semibold small", children: app.name }), app.description && _jsx("div", { className: "text-muted small", children: app.description }), app.items.length > 0 && _jsxs("table", { className: "table table-sm table-bordered small mb-1", style: { 'fontSize': '12px' }, children: [_jsx("thead", { children: _jsx("tr", { children: _jsx("th", { children: "Recommended Fluid" }) }) }), _jsx("tbody", { children: app.items.map((item, idx) => _jsx("tr", { children: _jsxs("td", { children: [formatSpec(item), item.tradeName && _jsxs("span", { className: "text-muted", children: [" (", item.tradeName, ")"] }), item.tempRange && _jsxs("span", { className: "text-muted", children: [" [", item.tempRange, "]"] })] }) }, idx)) })] }), app.capacities.length > 0 && _jsx("div", { style: { 'fontSize': '11px' }, children: flattenCapacities(app).map((cap, ci) => _jsxs("div", { className: "text-muted", children: [_jsxs("span", { className: "fw-semibold", children: [cap.name, ": "] }), _jsx("span", { children: cap.summary }), cap.notes.length > 0 ? _jsx("span", { children: ` \u2014 ${cap.notes.join(', ')}` }) : null] }, ci)) })] }, app.applicationId)) })] });
};
